import type { ApiClient } from '@travel/api-client';

import type {
  BonusProgramResponse,
  CouponParams,
  CouponResponse,
} from '@travel/traveler-core/store/dom-coupon/types';
import { BONUS_PROGRAM_API_ENDPOINT, COUPON_API_ENDPOINT } from './constants';

export const getDomCouponAPI = async (
  http: ApiClient,
  params: CouponParams,
): Promise<CouponResponse> => {
  // Pass requestString as a GET parameter via values
  return http.get(COUPON_API_ENDPOINT, {
    values: {
      requestString: params.requestString,
    },
    ignoreCommonErrorHandler: true,
    customParams: { isTravelAPI: 'COUPON', credentials: 'include' },
  });
};

export const getDomBonusProgramAPI = async (http: ApiClient): Promise<BonusProgramResponse> => {
  // Pass requestString as a GET parameter via values
  return http.get(BONUS_PROGRAM_API_ENDPOINT, {
    ignoreCommonErrorHandler: true,
    customParams: { isCouponAPI: true, credentials: 'include' },
  });
};
